/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import type { HTMLAttributes } from 'react';
import { type ForwardedRef, createContext, forwardRef, useContext } from 'react';
import type { FieldErrorProps } from 'react-aria-components';
import { type ContextValue, FieldErrorContext, FieldError as FieldErrorCore, Provider, Text as TextCore, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { IconContext } from '../icon/icon.component';

interface HintStyleProps {
  style?: stylex.StyleXStyles;
}

type HintProps = HintStyleProps & Omit<HTMLAttributes<HTMLElement>, 'style' | 'className' | 'children' | 'slot'> & {
  children?: FieldErrorProps['children'];
}

const HintContext = createContext<ContextValue<HintProps, HTMLElement>>({});

const Hint = forwardRef((props: HintProps, ref: ForwardedRef<HTMLElement>) => {
  [props, ref] = useContextProps(props, ref, HintContext);
  const validation = useContext(FieldErrorContext);

  const { style, children, ...coreProps } = props;

  return validation?.isInvalid
    ?
    <FieldErrorCore ref={ref} {...stylex.props(errorStyles.base, style)} {...coreProps}>
      {(renderProps) => (
        <Provider values={[
          [IconContext, {
            isFilled: true,
            size: 12,
            color: 'critical',
            children: (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.99991 10.9091C8.71113 10.9091 10.909 8.71122 10.909 6C10.909 3.28879 8.71113 1.09091 5.99991 1.09091C3.2887 1.09091 1.09082 3.28879 1.09082 6C1.09082 8.71122 3.2887 10.9091 5.99991 10.9091ZM5.45446 3.81818C5.45446 3.51694 5.69866 3.27273 5.99991 3.27273C6.30116 3.27273 6.54537 3.51694 6.54537 3.81818V6C6.54537 6.30125 6.30116 6.54546 5.99991 6.54546C5.69866 6.54546 5.45446 6.30125 5.45446 6V3.81818ZM6.68173 8.18182C6.68173 8.55838 6.37647 8.86364 5.99991 8.86364C5.62335 8.86364 5.31809 8.55838 5.31809 8.18182C5.31809 7.80526 5.62335 7.5 5.99991 7.5C6.37647 7.5 6.68173 7.80526 6.68173 8.18182Z" />
              </svg>
            )
          }]
        ]}>
          {typeof children === 'function' ? children(renderProps) : children}
        </Provider>
      )}
    </FieldErrorCore>
    :
    <TextCore
      ref={ref}
      slot="description"
      {...stylex.props(descriptionStyles.base, style)}
      {...coreProps}>
      <Provider values={[
        [IconContext, {
          isFilled: true,
          size: 12,
          color: 'quaternary',
          children: (
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path d="M5.5 2.875C5.15482 2.875 4.875 3.15482 4.875 3.5C4.875 3.84518 5.15482 4.125 5.5 4.125C5.84518 4.125 6.125 3.84518 6.125 3.5C6.125 3.15482 5.84518 2.875 5.5 2.875ZM5.5 8C5.77614 8 6 7.77614 6 7.5V5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5L5 7.5C5 7.77614 5.22386 8 5.5 8ZM5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10C7.98528 10 10 7.98528 10 5.5C10 3.01472 7.98528 1 5.5 1ZM5.5 2C7.433 2 9 3.567 9 5.5C9 7.433 7.433 9 5.5 9C3.567 9 2 7.433 2 5.5C2 3.567 3.567 2 5.5 2Z" />
            </svg>
          ),
        }]
      ]}>
        {typeof children === 'function' ?
          children({
            isInvalid: false,
            defaultChildren: null,
            validationDetails: {
              badInput: false,
              customError: false,
              patternMismatch: false,
              rangeOverflow: false,
              rangeUnderflow: false,
              stepMismatch: false,
              tooLong: false,
              tooShort: false,
              typeMismatch: false,
              valueMissing: false,
              valid: true
            },
            validationErrors: []
          }) :
          children}
      </Provider>
    </TextCore>;
});

export const errorStyles = stylex.create({
  base: {
    alignItems: 'center',
    alignSelf: 'stretch',
    color: $.textCritical,
    display: 'flex',
    fontFamily: 'BasierCircle',
    fontFeatureSettings: 'liga off, clig off',
    fontSize: 13,
    fontStyle: 'normal',
    fontWeight: 400,
    gap: '4px',
    letterSpacing: -0.26,
  },
});

export const descriptionStyles = stylex.create({
  base: {
    alignItems: 'center',
    alignSelf: 'stretch',
    color: $.textQuaternary,
    display: 'flex',
    fontFamily: 'BasierCircle',
    fontFeatureSettings: 'liga off, clig off',
    fontSize: 13,
    fontStyle: 'normal',
    fontWeight: 400,
    gap: '4px',
    letterSpacing: -0.26,
  },
});

export { Hint, HintContext, type HintProps, type HintStyleProps };
